import styles from './styles/BackGround.module.scss';
import { inject, observer } from 'mobx-react';
import { factorMapStr, factorMapEnStr } from '@/utils/contants/caseSimulation';
import withRouter from '@/components/withRouter';

import { ArrowRightOutlined } from '@ant-design/icons';
import { Space } from 'antd';
import useBackGround from '@/pages/hooks/CaseSImulation/useBackGround';
const BackGround = (props) => {
    const { onStart, onClickCard } = useBackGround(props);
    let { simulation } = props.store;

    let { background = {}, caseInfo } = simulation;
    let { sections = [] } = background;

    return (
        <div className={styles.container}>
            <div className={styles.scrollContent}>
                {/* 主标题 */}
                <div className={styles.title}>【{caseInfo?.case_title}】</div>

                <div className={styles.timeline}>
                    {sections.map((card, index) => (
                        <div onClick={onClickCard} key={card.section_id} data-index={index} className={`${styles.card}`}>
                            <div className={styles.cardTitle}>{card?.title}</div>
                            <div className={styles.cardBadge}>{factorMapStr[card?.section_id]}</div>
                            <div className={styles.cardLine}></div>
                            <div className={styles.cardContent}>{card?.content}</div>
                            <div className={styles.cardNumber}>{'0' + (index + 1)}</div>
                            <div className={styles.cardEnTitle}>{factorMapEnStr[card?.section_id]}</div>
                        </div>
                    ))}
                </div>

                {/* 故事提示 */}
                <div className={styles.storyInfo}>故事发生在...</div>
            </div>
            {/* 开始按钮 */}

            <div onClick={onStart} className={`${styles.button}`}>
                <Space>
                    <span> 现在开始</span>
                    <ArrowRightOutlined />
                </Space>
            </div>
        </div>
    );
};
export default withRouter(inject('store')(observer(BackGround)), 'background');
